package org.tlsys.api

class NotFoundException : RuntimeException()
